var CompactSubGeometry = (function () {
    function CompactSubGeometry() {
    }
    return CompactSubGeometry;
}());
export { CompactSubGeometry };
